import React from 'react';
import cn from 'classnames';

import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import parseInteger from 'utils/parsers/parseInteger.util';
import isPositiveInteger from 'utils/predicates/number/isPositiveInteger.util';

import CN from './SvgIcon.module.scss';

const DEFAULT_ALT_TEXT = 'icon';

// NOTE: try to keep these synchronized with the SCSS constants to avoid confusion
// SEE: src/styles/v2/size/icon.scss
const ABSOLUTE_SIZES = Object.freeze({
  xs: 23,
  sm: 16,
  md: 18,
  lg: 24,
});

const determineAbsoluteSize = (value) => {
  // the first one that gets an integer wins

  const predetermined = ABSOLUTE_SIZES[fromAnyToTrimmed(value)];
  if (isPositiveInteger(predetermined)) return predetermined;

  const parsed = parseInteger(value);
  if (isPositiveInteger(parsed)) return parsed;

  return null;
};

const SvgIcon = ({ icon, alt: altFromProps, size: sizeFromProps, tag: tagFromProps, ...extra }) => {
  // doesn't make sense to have an img if at least the icon path isn't there
  if (!icon) return null;

  const alt = fromAnyToTrimmed(altFromProps) || DEFAULT_ALT_TEXT;
  const tag = fromAnyToTrimmed(tagFromProps);
  const size = fromAnyToTrimmed(sizeFromProps);
  const pixels = determineAbsoluteSize(size);

  // these props will be set only if the absolute size is provided
  const absolute = pixels ? { width: pixels, height: pixels } : void 1;

  const componentClasses = cn({
    [CN.component]: true,
    [CN[`${size}Size`]]: !pixels && size, // if no absolute provided but there is relative one
    [CN.fullSize]: !pixels && !size, // if there is no absolute nor relative provided, default to full
  });

  return (
    <img
      {...extra}
      {...absolute}
      data-bem="SvgIcon"
      data-tag={tag}
      data-size={size}
      className={componentClasses}
      alt={alt}
      src={icon}
    />
  );
};

export default SvgIcon;
